import config from './config/config';

const history = {
  action: config.pushName
};

export default history;
